import reducers from './reducers'

export { default as deliveriesTypes } from './types'
export { default as deliveriesActions } from './actions'
export { default as deliveriesSelectors } from './selectors'

export default reducers
